import React, { FC } from "react"
import { VictoryLegend } from "victory"
import { colors } from "../../../utils/theme"

enum OUTCOME_NAME {
  GROWTH = "Accomplishment",
  ENJOYMENT = "Enjoyment",
  NORTH_STAR = "North Star",
}
const MoodGraphLegend: FC<{ showGrowth: boolean }> = ({ showGrowth }) => {
  const data = [{ name: OUTCOME_NAME.ENJOYMENT }, { name: OUTCOME_NAME.GROWTH }]
  const color = [colors.tertiary.orange, colors.primary.periwinkle]

  return (
    <VictoryLegend
      gutter={24}
      orientation={"horizontal"}
      height={30}
      x={16}
      symbolSpacer={5}
      style={{
        labels: {
          fontSize: 10,
          fontFamily: "Lato",
          fill: colors.neutral.denim,
        },
      }}
      data={showGrowth ? data : [data[0]]}
      colorScale={showGrowth ? color : [color[0]]}
    />
  )
}

export default MoodGraphLegend
